<template>
  <div>
    <CrudGrid
      :footer-text="$t('messages.items_per_page')"
      :headers="headers"
      :items="captationUnities"
      :loading="loading"
      :page="page"
      :page-count="numberOfPages"
      :options.sync="options"
      :sort-by.sync="sortBy"
    >
      <template v-slot:header>
        <div class="header-table">
          <CrudFilter :has-filters="hasFilters" @search="applyFilter" @clear="clearFilter">
            <v-list-item>
              <v-text-field
                color="#086318"
                :label="$t('inputs.captation_unities.description')"
                class="rounded-lg"
                hide-details
                outlined
                dense
                v-model="filterForm.description"
              />
            </v-list-item>
            <v-list-item>
              <v-select
                :items="type_references"
                item-value="id"
                item-text="description"
                color="#086318"
                :label="$t('inputs.captation_unities.type_reference')"
                class="rounded-lg"
                hide-details
                outlined
                dense
                v-model="filterForm.type_reference_id"
              />
            </v-list-item>
          </CrudFilter>
          <v-btn class="rounded-lg ml-2" elevation="1" color="#41916b" @click="openDialog()" data-cy="new-captation-unity-btn">
            <span class="textBtn">{{$t('buttons.new')}}</span>
          </v-btn>
        </div>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <Menu :resource="item" @editItemGrid="openDialog(item)">
          <ChangeStatus
            :resource="item"
            typeData="not-delete"
            @updateGrid="getDataTable()"
            url="references"
          />
        </Menu>
      </template>

      <template v-slot:[`item.status`]="{ item }">
        <v-chip :color="item.deleted_at ? '#fa5252' : '#bedfc5'" dark>
          {{ statusItem(item) }}
        </v-chip>
      </template>
    </CrudGrid>

    <Modal v-model="dialog">
      <CaptationUnitiesForm
        :openDialog="dialog"
        :resource="resource"
        @closeDialog="dialog = false, getDataTable()"
      />
    </Modal>
  </div>
</template>

<script>
import { getCaptationUnities } from "@/service/basic-registrations/CaptationUnitiesService";
import FormFieldsService from '@/service/FormFieldsService';
import CaptationUnitiesForm from "./CaptationUnities";
import Menu from "../widgets/MenuActions-comp.vue";
import ChangeStatus from "../widgets/ChangeStatus-comp.vue";
import CrudGrid from "../widgets/Grid.vue";
import CrudFilter from "../widgets/Filter.vue";
import Modal from "../widgets/Modal.vue";
import { mapActions } from "vuex";

export default {
  components: {
    ChangeStatus,
    CaptationUnitiesForm,
    Menu,
    CrudGrid,
    CrudFilter,
    Modal,
  },

  data() {
    return {
      dialog: false,
      filterForm: {},
      headers: [
        { text: "Descrição", align: "start", value: "description" },
        { text: "Tipos de Unidade", align: "start", value: "type_reference.description" },
        { text: "Status", align: "start", value: "status" },
        { text: "Ações", value: "actions", sortable: false, align: "center" },
      ],
      page: 1,
      numberOfPages: 0,
      loading: true,
      options: {},
      sortBy: "name",
      captationUnities: [],
      resource: {},
      type_references: [],
      actions: [
        {
          name: "Editar",
          type: "modal",
          route: "",
          encryptionName: "",
          encryptionPassword: "",
          componentName: "CaptationUnitiesForm",
        },
      ],
    };
  },

  computed: {
    hasFilters() {
      return Object.values(this.filterForm).some(v => v != null && v !== '');
    },
  },

  created() {
    this.getDataTable();
    this.changeActionsData(this.actions);
  },

  methods: {
    ...mapActions(["changeActionsData"]),

    async getDataTable() {
      this.loading = true;
      this.type_references = await FormFieldsService.getTypeReferences();
      getCaptationUnities(this.filterForm).then((result) => {
        this.loading = false;
        this.captationUnities = result;
      });
    },

    openDialog(item) {
      this.resource = item || {};
      this.dialog = true;
    },

    statusItem(item) {
      return item.deleted_at ? 'Inativo' : 'Ativo';
    },

    applyFilter() {
      this.getDataTable();
    },

    clearFilter() {
      this.filterForm = {};
      this.getDataTable();
    },
  },
};
</script>

<style scoped>
.header-table {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.textBtn {
  font-family: "Poppins";
  color: #ffffff;
}

@media (max-width: 768px) {
  .header-table {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>
